<template>
<div class="animation-container" ref="animationContainer"></div>
</template>

<script setup>
import { onMounted, ref, defineProps, onBeforeUnmount } from "vue"
import lottie from "lottie-web"

// 设置组件参数
const props = defineProps({
  renderer: 'svg',
  loop: true,
  autoplay: true,
  animationData: {}
})

// 创建 lottie接收变量
const animationInstance = ref()
const animationContainer = ref()

// 创建事件返回初始化lottie对象
// const emits = defineEmits(['getAnimation'])

// 初始化渲染 lottie动画，并返回 lottie对象
onMounted(() => {
  animationInstance.value = lottie.loadAnimation({
    container: animationContainer.value, // 绑定dom节点
    renderer: props.renderer, // 渲染方式:svg、canvas、html
    loop: props.loop, // 是否循环播放，默认：false
    autoplay: props.autoplay, // 是否自动播放, 默认true
    animationData: props.animationData, // AE动画使用bodymovie导出的json数据
    rendererSettings: {
      // 防止在 iOS 上出现闪烁
      preserveAspectRatio: 'xMidYMid slice',
      // 提高性能
      progressiveLoad: true,
      // 防止白屏
      hideOnTransparent: true
    }
  })
})
onBeforeUnmount(() => {
  if (animationInstance.value) {
    // 销毁动画实例
    animationInstance.value.destroy()
    animationInstance.value = null
  }
})
</script>

<style lang="scss" scoped>
.animation-container {
  width: 100%;
  height: 100%;
  /* 防止容器闪烁 */
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
